import React from "react";
import axiosInstance from "../../services/axios"
import {ActionTypes} from "../action-type"
import { resetSession, setSession } from "../../utils/session";
import { validateToken } from "../../utils/jwt";
import { general_notification } from "../../utils/notification";



export const getToken = async(username,password)=>{
    const formData = new FormData();
    formData.append("username", username);
    formData.append("password", password);
    try {
        const response = await axiosInstance.post("/auth/login", formData);
        setSession(response.data.access_token, response.data.refresh_token);

      } 
    catch (error) {
        throw error;
    }
};


export const initialize = (isAuthenticated,user)=>{
    return {
        type: ActionTypes.INITIALIZE,
        payload: {isAuthenticated,user}
    }
} 

export const loginUser = (username,password) => async (dispatch)=>{
    try{
        await getToken(username,password)
        const response = await axiosInstance.get("/users/me");
        const { data: user } = response;
        dispatch({
            type: ActionTypes.LOGIN,
            payload:{user}
        })

    }
    catch (err){
        //const {data} = err.response
        general_notification(err.response)
    }
}
export const logout =  (dispatch)=>{
    resetSession()
    dispatch({
        type: ActionTypes.LOGOUT
    })
}


export const AuthProvider =() => async (dispatch)=>{
    try{
        const accessToken = localStorage.getItem("accessToken");
        if (accessToken && validateToken(accessToken)){
        setSession(accessToken)
        const response = await axiosInstance.get("/users/me");
        const{data: user} = response;
        dispatch({
            type:ActionTypes.INITIALIZE,
            payload:{
                isAuthenticated:true,
                user,
            }
        })
        }
        else{
            dispatch({
                type:ActionTypes.INITIALIZE,
                payload:{
                    isAuthenticated:false,
                    user:null,
                }
            })   
        }

    }
    catch (error){
        dispatch({
            type:ActionTypes.INITIALIZE,
            payload:{
                isAuthenticated:false,
                user:null,
            }
        })
    }
}